import { createFileRoute } from '@tanstack/react-router';

import { InventoryRequisitionDashboard } from '../modules/Inventory/components/InventoryRequisitionDashboard';

export const Route = createFileRoute('/inventory-requests')({
  component: RouteComponent,
  head(ctx) {
    return {
      meta: [{ title: 'Inventory Requests' }],
    };
  },
});

function RouteComponent() {
  return (
    <div className="container mx-auto p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Inventory Requests</h1>
        <p className="text-muted-foreground mt-2">View and manage inventory requisitions</p>
      </div>
      <InventoryRequisitionDashboard />
    </div>
  );
}
